export default "__VITE_ASSET__BzUtXd6i__"